import "core-js/modules/es.array.push.js";
import Breadcrumbs from '../Breadcrumbs.vue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { LOCALE_CODE } from '@/common/constants/ConstCode';
export default {
  name: 'Navbar',
  components: {
    Breadcrumbs
  },
  data() {
    return {
      showMenu: false
    };
  },
  computed: {
    LOCALE_CODE() {
      return LOCALE_CODE;
    },
    ...mapGetters({
      loginData: 'admin/loginData'
    }),
    ...mapState('layout', ['isRTL', 'isNavFixed', 'darkMode']),
    currentRouteName() {
      return this.$route.name;
    },
    currentDirectory() {
      let dir = this.$route.path.split('/')[1];
      return dir.charAt(0).toUpperCase() + dir.slice(1);
    }
  },
  created() {
    this.minNav;
  },
  beforeUpdate() {
    this.toggleNavigationOnMobile();
  },
  methods: {
    fnChangeLocale(locale) {
      this.$i18n.locale = locale;
      // this.$store.commit('layout/updateKey');
    },
    changePassword() {
      this.$router.push('/changePassword');
    },
    logout() {
      if (!confirm('로그아웃하시겠습니까?')) return;
      this.$store.dispatch('admin/logout');
      this.$router.replace('/');
    },
    ...mapMutations('layout', ['navbarMinimize', 'toggleConfigurator']),
    ...mapActions('layout', ['toggleSidebarColor']),
    toggleNavigationOnMobile() {
      if (window.innerWidth < 1200) {
        this.navbarMinimize();
      }
    }
  }
};